/**
 * iter v28 r221 — User M1141: pulsante riusabile "?" che riapre tutte le
 * guide/banner nascoste della sezione corrente.
 *
 * iter v28 r363 — User M1273 (mobile bug): il toast diceva «Guide riaperte»
 * anche quando le chiavi erano OBSOLETE/SBAGLIATE → l'utente non vedeva
 * niente apparire. Ora prima di tutto controlliamo quante chiavi sono
 * effettivamente presenti in localStorage; se 0 mostriamo un toast diverso
 * («Tutte le guide sono già visibili») così l'utente sa subito che il
 * bottone ha funzionato ma non c'era niente da riaprire (≠ bug).
 *
 * Inoltre: se `keys` è vuoto, ricadiamo su `resetAllDismissedIntros()` →
 * cancella TUTTI i flag con prefisso `pronto:intro-dismissed:`, evitando
 * che configurazioni errate (chiavi non aggiornate) lascino l'utente bloccato.
 *
 * Uso:
 *   <ReopenGuidesBtn keys={["contatti:intro"]} />
 *   <ReopenGuidesBtn keys={["sopralluogo:studio-intro", "sopralluogo:live-intro"]} />
 *   <ReopenGuidesBtn keys={[]} />   // riapre TUTTE le guide globalmente (fallback)
 */
import React from "react";
import { Question } from "@phosphor-icons/react";
import { toast } from "sonner";
import { resetDismissedIntro, resetAllDismissedIntros } from "@/components/DismissibleIntro";

const STORAGE_PREFIX = "pronto:intro-dismissed:";

export default function ReopenGuidesBtn({ keys = [], testId = "reopen-guides" }) {
  const reopen = () => {
    let reopenedCount = 0;
    const safeKeys = Array.isArray(keys) ? keys.filter(Boolean) : [];

    if (safeKeys.length === 0) {
      // Fallback: nessuna chiave specificata → riapri tutto.
      reopenedCount = resetAllDismissedIntros();
    } else {
      // Conta solo le chiavi EFFETTIVAMENTE dismesse, così possiamo
      // distinguere "ho riaperto N guide" da "non c'era niente da riaprire".
      safeKeys.forEach((k) => {
        try {
          if (localStorage.getItem(`${STORAGE_PREFIX}${k}`)) {
            reopenedCount += 1;
          }
        } catch { /* ignore */ }
        resetDismissedIntro(k);
      });
    }

    // Notifica gli intro components che è stato fatto reset (ascoltato dal
    // pattern useState + storage listener di DismissibleIntro).
    window.dispatchEvent(new Event("pronto:intros-reset"));

    if (reopenedCount === 0) {
      toast.info("Le guide di questa sezione sono già visibili");
    } else if (reopenedCount === 1) {
      toast.success("Guida riaperta · la vedi qui sotto");
    } else {
      toast.success(`${reopenedCount} guide riaperte · le vedi qui sotto`);
    }
  };
  return (
    <button
      type="button"
      onClick={reopen}
      className="w-7 h-7 rounded-full border border-[#E5E7E0] text-[#9A968B] hover:text-[#7C8B6E] hover:border-[#7C8B6E] inline-flex items-center justify-center transition-colors flex-shrink-0"
      aria-label="Riapri la guida"
      title="Riapri la guida nascosta"
      data-testid={testId}
    >
      <Question size={14} weight="bold" />
    </button>
  );
}
